import Component from '../abstracts/Component';

export default class TwinWidgetCarouselComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-twin-carousel="true"]',
      
    };
  }


  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary() {

    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        this.initCarousels();
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      }
    )
  }

  initCarousels() {

    let carousels = document.querySelectorAll(this.SELECTORS.main);
      if (window.matchMedia('(max-width:767px)').matches){
          //console.log('media 767');
          for(let carousel of carousels){
              let slides = carousel.dataset.slides;
              let isDots = carousel.dataset.dots;
              let isCenter = carousel.dataset.centerslick;
              
              $(carousel).slick({
                  dots:isDots==='true'?true:false,
                  arrows:false,
                  infinite:false,
                  centerMode:isCenter==='true'?true:false,
                  slidesToShow: typeof(slides)!='undefined'? Number(slides):1
              });
          }
      }
      
  }

  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importLibrary();

    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      if ($('.vex').find('[data-carousel="true"]').length > 0) this.initCarousels();
    });

    this.$on(this.$customEvents.RETURN_EVENTS.subsituteProduct, () => {
      if (document.querySelectorAll(this.SELECTORS.main)) this.initCarousels();
    });

  }
}
